export default {
  title: {
    id: 'express_replacement_payment_title',
    defaultMessage: 'Confirm credit card details',
  },
  description: {
    id: 'express_replacement_description',
    defaultMessage:
      "You may see a $0 charge to your account. We're just checking that your credit card is valid.",
  },
  returnDeadlineReminder: {
    id: 'express_replacement_payment_return_deadline_reminder',
    defaultMessage:
      'You have until {date} to send the original device back after receiving your replacement. If you don’t make the return or if it has additional damage, you’ll be charged the same amount as your original device.',
  },
  replacementOrderTitle: {
    id: 'express_replacement_payment_replacement_order_title',
    defaultMessage: 'Your replacement order',
  },
  paymentFormTitle: {
    id: 'express_replacement_payment_form_title',
    defaultMessage: 'Credit card check',
  },
  paymentFormInfoBlockTitle: {
    id: 'express_replacement_payment_form_info_block_title',
    defaultMessage: 'No charge to your card',
  },
  paymentFormInfoBlockContent: {
    id: 'express_replacement_payment_form_info_block_content',
    defaultMessage:
      'Your bank may ask you to confirm a payment of $0. Confirm this so that we can mark your credit card as valid.',
  },
  paymentFormInfoBlockLink: {
    id: 'express_replacement_payment_form_info_block_link',
    defaultMessage: 'Learn more',
  },
}
